
import Vue from "vue";
import _com from "./common";

export default function intercept(type?:any) {
    if (!_com.getMallCookie()) {
        let roomData: any = sessionStorage.getItem('roomData')
        roomData = JSON.parse(roomData)
        let url = location.href.indexOf('sourceOfJump')
        let urlOrigin = location.href.indexOf('origin')
        let liandengId = process.env.VUE_APP_URI_DOMAIN == '.beta.ule.com' ? '0f6258b721d04abc96c893cf84740fb2' : '8c8d70950ed04e1a9516559d35b784fc'
        // 分期商城
        if (urlOrigin > -1) {  // 来源---分期商城
            let toUrl = ''
            if (process.env.VUE_APP_URI_DOMAIN == '.beta.ule.com') {
                toUrl += 'https://m.beta.ule.com/mthirdparty/psbcshop/shopUnionLogin/'
            } else {
                toUrl += 'https://m.ule.com/mthirdparty/psbcshop/shopUnionLogin/'
            }
            if (location.href.indexOf('origin=yzlife') > -1) { // 邮生活APP 邮生活公众号
                let href = location.href
                location.href = toUrl + 'h5?target=' + encodeURIComponent(href) + '&roomNumber=' + roomData.roomNumber + '&sceneNumber=' + roomData.scene_number + '&origin=yzlife'
            } else if (location.href.indexOf('origin=pmcc') > -1) {  // 邮储信用卡APP
                let href = location.href
                location.href = toUrl + 'h5?target=' + encodeURIComponent(href) + '&roomNumber=' + roomData.roomNumber + '&sceneNumber=' + roomData.scene_number + '&origin=pmcc'
            }
            return false
        }



        if (_com.browser().yshapp) { // 邮生活App
            let dataApp = {
                "closeCurrentPage": "0",
                "realName": "0",
                "appid": liandengId,
                "targetUrl": `https://m${process.env.VUE_APP_URI_DOMAIN}/mthirdparty/tp/yshUnionLogin?redirectUrl=${encodeURIComponent(window.location.href)}`
            };
            // closeCurrentPage  当前h5页面是否关闭 0=不关闭；1=关闭
            // realName  是否需要实名校验 0=不需要；1=需要
            // targetUrl 联合登陆后跳转地址
            (<any>window).Emp.execute("callApp('thirdH5_goToJointLogin','goToJointLogin','" + JSON.stringify(dataApp) + "')");
            return false
        } else if (url > -1) {   // 来源---邮生活
            if (location.href.indexOf('yshmp') > -1) { // 邮生活小程序
                let href = location.href.replace('?sourceOfJump=yshmp', '');
                (<any>window).wx.miniProgram.navigateTo({ url: '/pages/commonToThird/commonToThird?appId=' + liandengId + '&targetUrl=' + encodeURIComponent("https://m" + process.env.VUE_APP_URI_DOMAIN + "/mthirdparty/tp/crmUnionLogin?roomNumber" + roomData.roomNumber + "&scene_number" + roomData.scene_number + "&from=yshmp&redirectUrl=" + encodeURIComponent(href)) + '&isNeedRealName=0' })
            } else if (location.href.indexOf('yshgzh') > -1) { // 邮生活公众号
                let href = location.href.replace('?sourceOfJump=yshgzh', '');
                let toUrl = ''
                if (process.env.VUE_APP_URI_DOMAIN == '.beta.ule.com') {//邮生活没有testing
                    toUrl += "https://youshenghuo.trial.cpsdc.com.cn/wx/#/toThird?toUrl=" + encodeURIComponent("https://m" + process.env.VUE_APP_URI_DOMAIN + "/mthirdparty/tp/crmUnionLogin?roomNumber" + roomData.roomNumber + "&scene_number" + roomData.scene_number + "&from=yshmp&redirectUrl=" + encodeURIComponent(href)) + "&appId=" + liandengId
                } else {
                    toUrl += "https://youshenghuo.11185.cn/wx/#/toThird?toUrl=" + encodeURIComponent("https://m" + process.env.VUE_APP_URI_DOMAIN + "/mthirdparty/tp/crmUnionLogin?roomNumber" + roomData.roomNumber + "&scene_number" + roomData.scene_number + "&from=yshmp&redirectUrl=" + encodeURIComponent(href)) + "&appId=" + liandengId
                }
                location.href = toUrl;
            }
            return false
        } else {
            if (Vue.prototype.source == 'uzg') {
                //mallCookie判断是否登录
                location.href = "https://www" + process.env.VUE_APP_URI_DOMAIN + "/yzg/app/entry/index.html#/?businessType=1002|link=" + location.href;
                return false;
            } else {
                //mallCookie判断是否登录
                if(type=='guanzhu'){
                    if (Vue.prototype.scene_number && Vue.prototype.scene_number != 'undefined' && location.href.indexOf("scene_number") < 0) {
                        if (location.href.indexOf("?") < 0) {
                            location.href = "https://m" + process.env.VUE_APP_URI_DOMAIN + "/muser/user/login?target=" + encodeURIComponent(location.href + "?scene_number=" + Vue.prototype.scene_number) + "&ul_aid=ule_live_attention";
                        } else {
                            location.href = "https://m" + process.env.VUE_APP_URI_DOMAIN + "/muser/user/login?target=" + encodeURIComponent(location.href + "&scene_number=" + Vue.prototype.scene_number) + "&ul_aid=ule_live_attention";
                        }
                    } else {
                        location.href = "https://m" + process.env.VUE_APP_URI_DOMAIN + "/muser/user/login?target=" + encodeURIComponent(location.href) + "&ul_aid=ule_live_attention";
                    }
                    return false;
                }
                if (Vue.prototype.scene_number && Vue.prototype.scene_number != 'undefined' && location.href.indexOf("scene_number") < 0) {
                    if (location.href.indexOf("?") < 0) {
                        location.href = "https://m" + process.env.VUE_APP_URI_DOMAIN + "/muser/user/login?target=" + encodeURIComponent(location.href + "?scene_number=" + Vue.prototype.scene_number);
                    } else {
                        location.href = "https://m" + process.env.VUE_APP_URI_DOMAIN + "/muser/user/login?target=" + encodeURIComponent(location.href + "&scene_number=" + Vue.prototype.scene_number);
                    }
                } else {
                    location.href = "https://m" + process.env.VUE_APP_URI_DOMAIN + "/muser/user/login?target=" + encodeURIComponent(location.href);
                }
                return false;
            }
        }
        // 1
        // else if (Vue.prototype.source == 'ysh') {
        //     if (!_com.getCrmMemberInfo()) {
        //         let from = '', href = location.href, toUrl = ''
        //         if (_com.browser().yshapp) {
        //             from = 'yshapp'
        //             if (!(_com.getQueryString('from'))) {
        //                 if (href.indexOf('from=') > -1) {
        //                     href = href.replace('from=', 'from=' + from)
        //                 } else {
        //                     if (href.indexOf('?') < 0) {
        //                         href += '?from=' + from
        //                     } else {
        //                         href += '&from=' + from
        //                     }
        //                 }
        //             }
        //         } else if (_com.getQueryString('from') == 'yshmp') {
        //             from = 'yshmp'
        //         }
        //         if (process.env.VUE_APP_URI_DOMAIN == '.beta.ule.com') {//邮生活没有testing
        //             toUrl += "https://youshenghuo.trial.cpsdc.com.cn/wx/#/toThird?toUrl=" + encodeURIComponent("https://m" + process.env.VUE_APP_URI_DOMAIN + "/mthirdparty/tp/crmUnionLogin?from=" + from + "&redirectUrl=" + encodeURIComponent(href)) + "&appId=0f6258b721d04abc96c893cf84740fb2"
        //         } else {
        //             toUrl += "https://youshenghuo.11185.cn/wx/#/toThird?toUrl=" + encodeURIComponent("https://m" + process.env.VUE_APP_URI_DOMAIN + "/mthirdparty/tp/crmUnionLogin?from=" + from + "&redirectUrl=" + encodeURIComponent(href)) + "&appId=8c8d70950ed04e1a9516559d35b784fc"
        //         }
        //         location.href = toUrl;
        //         return false
        //     }
        // } 
    }
    return true;
};

